module.exports = __webpack_public_path__ + "img/7a1eecb725cd6e55e26ac271649a0b70.png";